export interface Testimonial {
  quote: string
  name: string
  role: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      '“My whole season was planned in an afternoon. I have not written a lesson from scratch since.”',
    name: 'Name Placeholder',
    role: 'Club Coach',
  },
  {
    quote:
      '“The group variants saved me. Two players or eight, the drill still works.”',
    name: 'Name Placeholder',
    role: 'Academy Instructor',
  },
  {
    quote:
      '“I teach PE, not tennis. This is the first system I could open and just run.”',
    name: 'Name Placeholder',
    role: 'PE Teacher',
  },
  {
    quote:
      '“Parents finally get a real answer when they ask what their child is working on.”',
    name: 'Name Placeholder',
    role: 'Junior Programme Lead',
  },
  {
    quote:
      '“The scored assessments made progress visible for the first time in my club.”',
    name: 'Name Placeholder',
    role: 'Head Coach',
  },
  {
    quote:
      '“Printed the whole Foundation volume and left it in the court bag. It never leaves.”',
    name: 'Name Placeholder',
    role: 'Community Coach',
  },
]
